// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {Callout} from '@wandb/weave/components/Callout';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {useGoToBaseUrl} from '../hooks/hooks';

export const FullScreenPanelNotFound = () => {
  const goToBaseUrl = useGoToBaseUrl();
  return (
    <Tailwind
      style={{
        width: '100%',
        height: '100%',
        zIndex: 1,
        position: 'relative',
      }}>
      <div className="flex h-full w-full flex-col items-center bg-white pt-[250px]">
        <Callout className="mb-16" size="small" icon="spiral" color="purple" />
        <div className="text-xl font-semibold">Panel not found</div>
        <div className="text-moon-600">
          This panel does not exist. Please check your URL.
        </div>
        <Button className="mt-16" variant="secondary" onClick={goToBaseUrl}>
          Back to workspace
        </Button>
      </div>
    </Tailwind>
  );
};
